import React from 'react';
import dynamicfunction from '../utils/dynamicfunction';
import { cn } from '../utils/utils';

const ViewReverse = ({ children, className, style, onClick, isReverse = true, isResponsive = false, props }) => {
  const { isArabic } = dynamicfunction();

  const classes = isResponsive ? `flex-col ${isArabic && isReverse ? 'md:flex-row-reverse' : 'md:flex-row'}` : isArabic && isReverse ? 'flex-row-reverse' : 'flex-row';

  return (
    <div
      className={cn('flex', classes, onClick && 'cursor-pointer', className)}
      style={style}
      onClick={onClick}
      {...props}
    >
      {children}
    </div>
  );
};

export default ViewReverse;
